@use '../../../scss//mixins' as *;

.RichTextField {
  /* 
    force links to wrap w/hyphenation
    https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container
  */
  > a {
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;
    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  > p {
    line-height: 1.56;
    // prevent plain-text links from overflowing & breaking layout
    overflow: hidden;

    &.text-align-center {
      text-align: center;
    }

    &.text-align-right {
      text-align: right;
    }
  }

  > p:focus-within {
    overflow: visible; 
  }

  > ol {
    list-style-type: decimal;
  }

  > ul {
    list-style-type: disc;
  }

  // BELOW: must propagate enforced styles to inner components
  
  > * ol {
    list-style-type: decimal;
  }

  > * ul {
    list-style-type: disc;
  }
}